import * as React from 'react'
import { useDispatch } from 'react-redux'
import { withTranslation, WithTranslation } from 'react-i18next'
import { checklistUpdateComponent } from '../../../../redux/actions'
import FormComponentBuilder, { FormComponentBuilderChildrenProps } from '../FormComponent/FormComponentBuilder'
import { useState } from 'react'

export interface ComponentData {
  id: string
  optional: boolean
  type: {
    type: string
    values: string[]
  }
  defaultValue: string
  lastValue: string
}

export interface StateProps {
  componentData: ComponentData
  checklistInstanceId: string
  checkId: string
}

export interface OwnProps {
  disabled: boolean
  collapseHandler?: Function
}

export type Props = StateProps & OwnProps & WithTranslation

export class TextComponent extends React.Component<Props> {
  constructor(props: Props) {
    super(props)
    this.manageCollapsable()
  }

  private manageCollapsable() {
    if (this.props.componentData.lastValue && this.props.componentData.optional && this.props.collapseHandler) {
      this.props.collapseHandler()
    }
  }

  public render() {
    return (
      <div className="collapse cl-controls-optional cl-controls-optional-1 show">
        <FormComponentBuilder<string> component={this.props.componentData}>
          {formProps => {
            return (
              <_Textarea
                {...formProps}
                checklistInstanceId={this.props.checklistInstanceId}
                componentId={this.props.componentData.id}
              />
            )
          }}
        </FormComponentBuilder>
      </div>
    )
  }
}

function _Textarea(
  props: FormComponentBuilderChildrenProps<string> & { checklistInstanceId: string; componentId: string }
): JSX.Element {
  const { value, onChange, onBlur } = useInputComponent(props)

  return (
    <textarea
      className={`form-control ${props.className}`}
      value={value}
      id="exampleFormControlTextarea1"
      rows={3}
      onChange={onChange}
      onBlur={onBlur}
      disabled={props.disabled}
    />
  )
}

function useInputComponent(
  props: FormComponentBuilderChildrenProps<string> & {
    checklistInstanceId: string
    componentId: string
  }
) {
  const [internalValue, setInternalValue] = useState(props.value)
  const dispatch = useDispatch()

  React.useEffect(() => {
    setInternalValue(props.value)
  }, [props.value])

  const onChange = React.useCallback((event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setInternalValue(event.target.value)
  }, [])

  const onBlur = React.useCallback((event: React.FocusEvent<HTMLTextAreaElement>) => {
    dispatch(checklistUpdateComponent(props.checklistInstanceId, props.componentId, event.target.value, false))
    props.onBlur()
  }, [])

  return {
    value: internalValue,
    onChange,
    onBlur,
  }
}

export default withTranslation()(TextComponent)
